<template>
    <table class="ui compact structured printable sixteen column center aligned fixed table"
        style="table-layout: fixed; height: 100%;">
        <tbody>
            <tr>
                <td class="two wide two-height" colspan="2" rowspan="2">
                    <img :src="logo_url" class="logo image">
                </td>
                <td class="four wide" colspan="4">
                    <h3 class="ui header" style="margin-top: 3px;">
                        {{ title || blank_value_text }}
                        <div class="sub header">
                            {{ sub_title || blank_value_text }}
                        </div>
                    </h3>
                </td>
                <td class="two wide" colspan="2">
                    <div class="sub icon header">
                        <i class="phone icon"></i>客服專線
                        <div class="content">
                            {{ customer_service_hotline || blank_value_text }}
                        </div>
                    </div>
                </td>
                <td class="five wide two-height" colspan="5" rowspan="2">
                    <barcode
                        :value="core_waybill.number"
                        :tag="'svg'"
                        :options="{
                            background: 'transparent',
                            displayValue: true,
                            format: 'CODE128',
                            width: 1,
                            height: 25
                        }">
                        看見此資訊請通知系統工程師。
                    </barcode>
                </td>
                <td class="three wide two-height" colspan="3" rowspan="2">
                    <h5 class="ui sub header">配達區</h5><br>
                    {{ force_location || distribution_object_name || blank_value_text }}
                </td>
            </tr>
            <tr>
                <td class="two wide" colspan="2">
                    <h5 class="ui sub header">
                        出單日
                    </h5>
                </td>
                <td class="four wide" colspan="4">
                    {{ human_datetime("today", "l") || blank_value_text }}
                </td>
            </tr>
            <tr>
                <td class="one wide four-height" rowspan="4">
                    <h5 class="ui header">收</h5>
                    <h5 class="ui header">件</h5>
                    <h5 class="ui header">人</h5>
                </td>
                <td class="one wide" colspan="1">
                    <h5 class="ui sub header">
                        名稱
                    </h5>
                </td>
                <td class="six wide" colspan="6">
                    <div class="one height">
                        {{ consignee_name_and_company_name }}
                        <!-- {{ core_waybill.consignee_name || blank_value_text }} -->
                    </div>
                </td>
                <td class="one wide" colspan="1">
                    <h5 class="ui sub header">
                        件數
                    </h5>
                </td>
                <td class="one wide" colspan="1">
                    <span v-if="$store.state.provider.node.host != 'qh.tw568.com'">{{ core_waybill.pieces }}</span>
                </td>
                <td class="one wide" colspan="1">
                    <h5 class="ui sub header">
                        重量
                    </h5>
                </td>
                <td class="one wide" colspan="1">
                    <span v-if="$store.state.provider.node.host != 'qh.tw568.com'">{{ core_waybill.weight_in_kilo || 0 }}</span>
                </td>
                <td class="four wide" colspan="4" rowspan="1">
                    <h5 class="ui sub header">
                        配&emsp;送&emsp;訊&emsp;息
                    </h5>
                </td>
            </tr>
            <tr>
                <td class="one wide" colspan="1">
                    <h5 class="ui sub header">
                        電話
                    </h5>
                </td>
                <td class="six wide" colspan="6">
                    <div class="one height">
                        {{ core_waybill.consignee_phone || blank_value_text }}
                    </div>
                </td>
                <td class="two wide" colspan="2">
                    {{ core_waybill.shipping_date || blank_value_text }}
                </td>
                <td class="one wide" colspan="1">
                    <h5 class="ui sub header">
                        時段
                    </h5>
                </td>
                <td class="one wide" colspan="1">
                    {{ core_waybill.shipping_period || blank_value_text }}
                </td>
                <td class="four wide three-height" colspan="4" rowspan="3">
                    <div class="three height">
                        <p v-if="core_waybill.goods_name" style="padding-top: 3px;">
                            品名：{{ core_waybill.goods_name || blank_value_text }}
                        </p>
                    </div>
                    <barcode
                        :value="core_waybill.original_number"
                        :tag="'svg'"
                        :options="{
                            background: 'transparent',
                            displayValue: true,
                            format: 'CODE128',
                            width: 1,
                            height: 25
                        }">
                        看見此資訊請通知系統工程師。
                    </barcode>
                </td>
            </tr>
            <tr>
                <td class="one wide" colspan="1" rowspan="1">
                    <h5 class="ui sub header" style="margin-top:0;">
                        地址
                    </h5>
                </td>
                <td class="six wide" colspan="6" rowspan="1">
                    <div class="two height" style="font-size: 12px; line-height: 16px;padding-top: 2px;">
                        {{ core_waybill.consignee_address || blank_value_text }}
                    </div>
                </td>
                <td class="four wide" colspan="4">
                    {{ core_waybill.shipping_note || core_waybill.note || blank_value_text }}
                </td>
            </tr>
            <tr>
                <td class="one wide" colspan="1">
                    <h5 class="ui sub header">
                        原單號
                    </h5>
                </td>
                <td class="six wide right" colspan="6">
                    <div class="one height">
                        {{ core_waybill.original_number || blank_value_text }}
                    </div>
                </td>
                <td class="one wide" colspan="1" rowspan="1">
                    運費
                </td>
                <td class="three wide" colspan="3" rowspan="1">
                    <h2 class="ui header" v-html="fee">
                    </h2>
                </td>
            </tr>
            <tr>
                <td class="one wide three-height" rowspan="3">
                    <h5 class="ui header" style="margin-top: 3px;">寄</h5>
                    <h5 class="ui header">件</h5>
                    <h5 class="ui header">人</h5>
                </td>
                <td class="one wide" colspan="1">
                    <h5 class="ui sub header">
                        名稱
                    </h5>
                </td>
                <td class="six wide" colspan="6">
                    <div class="one height">
                        {{ sender_name_and_company_name }}
                        <!-- {{ core_waybill.sender_name || blank_value_text }} -->
                    </div>
                </td>
                <td class="two wide left top bold" colspan="2">
                    <h6 class="ui sub header">代收貨款</h6>
                </td>
                <td class="two wide top bold" colspan="2"><h6 class="ui sub header">{{ thousands_separator(collection_fee) }}<span class="unit">元</span></h6></td>
                <!-- <td class="four wide top left bottom bold" colspan="4" rowspan="3">
                    <table class="ui very basic table" style="height: 100%;">
                        <tbody>
                            <tr>
                                <td>
                                    <h6 class="ui sub header">代收貨款</h6>
                                </td>
                                <td>
                                    <h6 class="ui sub header">
                                        {{ thousands_separator(collection_fee) }}
                                    </h6>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <h6 class="ui sub header">
                                        報關費
                                    </h6>
                                </td>
                                <td>
                                    <h6 class="ui sub header">
                                        {{ thousands_separator(declaration_fee) }}
                                    </h6>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <h6 class="ui sub header">
                                        稅金
                                    </h6>
                                </td>
                                <td>
                                    <h6 class="ui sub header">
                                        {{ thousands_separator(tax) }}
                                    </h6>
                                </td>
                            </tr>
                            <tr>
                            <td>
                                <h6 class="ui sub header">
                                    合計
                                </h6>
                            </td>
                            <td>
                                <h6 class="ui sub header">
                                    {{ thousands_separator(total_amount) }}
                                </h6>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </td> -->
                <td class="four wide left top right bold" colspan="4" rowspan="1">
                    <h5 class="ui sub header">
                        簽收欄（請簽全名或蓋章）
                    </h5>
                </td>
            </tr>
            <tr>
                <td class="one wide" colspan="1">
                    <h5 class="ui sub header">
                        電話
                    </h5>
                </td>
                <td class="six wide" colspan="6">
                    <div class="one height">
                        {{ core_waybill.sender_phone || blank_value_text }}
                    </div>
                </td>
                <td class="two wide left bold" colspan="2"><h6 class="ui sub header">稅金</h6></td>
                <td class="two wide" colspan="2"><h6 class="ui sub header">{{ thousands_separator(tax) }}<span class="unit">元</span></h6></td>
                <td class="four wide left bottom right bold three-height" colspan="4" rowspan="4">
                </td>
            </tr>
            <tr>
                <td class="one wide" colspan="1">
                    <h5 class="ui sub header" style="margin-top:0;">
                        地址
                    </h5>
                </td>
                <td class="six wide right" colspan="6">
                    <div class="one height" style="font-size: 12px; line-height: 16px;padding-top: 2px;">
                        {{ core_waybill.sender_address || blank_value_text }}
                    </div>
                </td>
                <td class="two wide left bold" colspan="2"><h6 class="ui sub header">合計</h6></td>
                <td class="two wide" colspan="2"><h6 class="ui sub header">{{ thousands_separator(total_amount) }}<span class="unit">元</span></h6></td>
            </tr>
            <tr>
                <td class="two wide" colspan="2" rowspan="2">
                    <h5 class="ui sub header">
                        配送人員簽名
                    </h5>
                </td>
                <td class="four wide" colspan="6" rowspan="2" style="position: relative;">
                    <span style="position: absolute;right: 5px;bottom: 5px;color: lightgray;font-size: 0.8em;">{{ logistician.name }}({{ logistician.username }})</span>
                </td>
                <td class="four wide left bottom bold" colspan="1" rowspan="2">
                    子單
                </td>
                <td class="one wide"><h6 class="ui sub header">配送中</h6></td>
                <td class="one wide"><h6 class="ui sub header">已配達</h6></td>
                <td class="one wide right bold"><h6 class="ui sub header">總件數</h6></td>
            </tr>
            <tr>
                <td class="one wide bottom bold">
                    <div style="font-size: 0.8em;" v-if="core_waybill.child_core_waybills_count > 0 && core_waybill.shipping_child_core_waybills_count != undefined">
                        {{ core_waybill.shipping_child_core_waybills_count }}
                        <span class="unit">件</span>
                    </div>
                    <div v-else>-</div>
                </td>
                <td class="one wide bottom bold">
                    <div style="font-size: 0.8em;" v-if="core_waybill.child_core_waybills_count > 0 && core_waybill.delivered_child_core_waybills_count != undefined">
                        {{ core_waybill.delivered_child_core_waybills_count }}
                        <span class="unit">件</span>
                    </div>
                    <div v-else>-</div>
                </td>
                <td class="one wide right bottom bold">
                    <div style="font-size: 0.8em;" v-if="core_waybill.child_core_waybills_count > 0 && core_waybill.child_core_waybills_count != undefined">
                        {{ core_waybill.child_core_waybills_count }}
                        <span class="unit">件</span>
                    </div>
                    <div v-else>-</div>
                </td>
            </tr>
        </tbody>
    </table>
</template>

<script>
import VueBarcode from '@chenfengyuan/vue-barcode'
import VueQrcode from '@chenfengyuan/vue-qrcode'
import moment from 'moment'
export default {
    props: {
        core_waybill: {
            type: Object,
            default() {
                return {
                    identity: null,
                    number: null,
                    consignee_name: null,
                    consignee_phone: null,
                    consignee_address: null,
                    original_number: null,
                    sender_name: null,
                    sender_phone: null,
                    sender_address: null,
                    // 件數最少顯示1（表示運單底下沒有子單只有自己）
                    pieces: null,
                    weight_in_kilo: null,
                    collection: null,
                    goods_name: null,
                    shipping_date: null,
                    shipping_period: null,
                    shipping_note: null,
                }
            }
        },
        logo_url: String,
        title: String,
        sub_title: String,
        customer_service_hotline: String,
        logistician: Object,
        force_location: String,
        show_print_button: {
            type: Boolean,
            default: false,
        },
        blank_value_text: {
            type: String,
            default: null,
        }
    },
    computed: {
        consignee_name_and_company_name() {
            var name = this.core_waybill.consignee_name || ""
            var company_name = this.core_waybill.consignee_company_name || ""
            var srting = (name && company_name) ? " / " : ""
            return name + srting + company_name
        },
        sender_name_and_company_name() {
            var name = this.core_waybill.sender_name || ""
            var company_name = this.core_waybill.sender_company_name || ""
            var srting = (name && company_name) ? " / " : ""
            return name + srting + company_name
        },
        collection_fee() {
            return this.core_waybill.collection + this.core_waybill.consignee_tax_point || 0
        },
        declaration_fee() {
            return this.core_waybill.simplified_declaration_form_fee + this.core_waybill.declaration_form_fee || 0
        },
        tax() {
            return this.core_waybill.tax || 0
        },
        total_amount() {
            return this.collection_fee + this.declaration_fee + this.tax || 0
        },
        fee() {
            var fee_text = ""
            switch (this.core_waybill.payment_type) {
                case "cash_by_consignee":
                    fee_text += ("到付<br> $" + this.core_waybill.charge)
                    break
                case "cash_by_sender":
                    fee_text += ("寄付<br> $" + this.core_waybill.charge)
                    break
                case "monthly":
                    fee_text += "月結"
                    break
                default:
                    if (this.core_waybill.charge) {
                        fee_text += this.core_waybill.charge
                    }
            }
            return fee_text
        },
        distribution_object_name() {
            try {
                return distribution.object.name
            } catch (e) {
                return null
            } finally {

            }
        }
    },
    data() {
        return {
            paper_size: "A5",
            template: "",
            distribution: {
                object: {
                    name: null,
                }
            },
        }
    },
    watch: {
    },
    mounted() {
    },
    methods: {
        thousands_separator(value) {
            return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        },
        async print() {
            await new Promise(resolve => {
                $(this.$refs.printable).clone().appendTo('div#print')
            })
            await new Promise(resolve => {
                window.print()
            })
        },
        fetch_distribution() {
            if (this.core_waybill.identity) {
                var url = new RestUrl(this.$store.state.provider.routes.api_v1_provider_core_waybill_distribute).parse(
                    {core_waybill_identity: this.core_waybill.identity},
                    ""
                )
                return axios.get(url, {headers: { Authorization: localStorage.getItem("authentication_token") }})
                .then(response => {
                    if (response.data.status == "success") {
                        this.distribution = response.data.distribution
                    } else if (response.data.status == "failure") {
                        this.errors = response.data.errors
                        // this.$noty.error("抓取分撥失敗")
                        this.$noty.error(
                            this.$t('ui.notifications.error.fetch__name', {
                                name: this.$t('models.distributions'),
                                reason: ': ' + response.data.errors
                            })
                        )
                    }
                    return response
                })
                .catch(error => {
                    // this.errors.push("抓取分撥失敗" + this.$t('ui.general.network_abnormality')+": "+ error.response.status)
                    this.$noty.error(
                        this.$t('ui.notifications.error.fetch__name', {
                            name: this.$t('models.distributions'),
                            reason: ': ' +this.$t('ui.general.network_abnormality')+','+ error.response.status
                        })
                    )
                    return Promise.reject(error)
                })
                .then(() => {
                })
            } else {
                return Promise.resolve()
            }

        },
    },
    components: {
        'barcode': VueBarcode,
        'qrcode': VueQrcode
    }
}
</script>

<style scoped lang="scss">
.ui.sub.header {
    margin-top: 3px;
}
.prices {
    td {
        height: var(--my-receipts-table-half-height) !important;
    }
    .ui.header {
        font-size: 14px;
        margin-bottom: -1px;
        padding-left: 6px;
    }
}
.unit {
    float: right;
    margin-right: 5px;
}
</style>
